import * as React from 'react';
import styled from 'styled-components';
import {Skeleton, SkeletonProps} from '@material-ui/lab';

const SkeletonRing = styled(Skeleton)`
    position: absolute;
    top: 10%;
    left: 10%;
    width: 80%;
    min-width: 80%;
    height: 80% !important;

    border: ${p => p.theme.muiTheme.spacing(10)}px solid
        ${p => p.theme.muiTheme.palette.secondary.main};
`;

export interface PieChartSkeletonProps {
    animation?: SkeletonProps['animation'];
}

export const PieChartSkeleton: React.FC<PieChartSkeletonProps> = ({animation}) => (
    <SkeletonRing variant="circle" animation={animation} />
);
